import PropTypes from 'prop-types'
import React from 'react'
import CommentView from './comment-view'

export default class CommentSection extends React.Component {
    static propTypes = {
        comments: PropTypes.array.isRequired,
    }

    render() {
        const comments = this.props.comments.sort(function compare(a, b) {
            return new Date(b.submitted_at) - new Date(a.submitted_at)
        })

        return (
            <div className="container my-2">
                {comments.map((c, ix) => (
                    <CommentView
                        key={c._id}
                        comment={c}
                        index={ix}
                        idea_id={this.props.idea_id}
                    />
                ))}
            </div>
        )
    }
}
